import { ConversationMessage } from "@mirage/service-conversation/types";

const MESSAGE_AUTHOR_MAP = {
  assistantMessage: "Assistant Message:",
  userMessage: "User Message:",
  systemMessage: "System Message:",
  toolMessage: "Tool Message:",
};

export const generateConversationLog = (messages: ConversationMessage[]) => {
  return messages.reduce((log, message) => {
    // If the message is not well-formed, skip it
    if (!message.messageType || !message.messageType.case) {
      return log;
    }

    // Prepend each message with its author
    log += `${MESSAGE_AUTHOR_MAP[message.messageType.case]}\n`;

    if (
      message.messageType.case === "assistantMessage" &&
      message.messageType.value.agentId === "fs:dash-calendar-agent"
    ) {
      // If the message is a calendar agent message, append basic information about each event
      if (message.jsonContent?.calendarEvents) {
        log += "\tCalendar Events:\n";

        message.jsonContent.calendarEvents.forEach((event, idx, arr) => {
          if (event.meetingInfo) {
            log += `\t\tID: ${event.meetingInfo.id}\n`;
            log += `\t\tSummary: ${event.meetingInfo.summary}\n`;
            log += `\t\tStart: ${_get_formatted_datetime(event.meetingInfo.startMs)}\n`;
            log += `\t\tEnd: ${_get_formatted_datetime(event.meetingInfo.endMs)}`;

            if (idx < arr.length - 1) {
              log += "\n\n";
            }
          }
        });
      }
    } else {
      // Otherwise, append the message content
      log += `${message.messageType.value.text}`;

      // If the message has jsonContent representing a write draft, append that content also
      if (message.jsonContent?.content) {
        log += `\n\nCompose Draft:\n${message.jsonContent.content}`;
      }
    }

    return log + "\n\n\n\n";
  }, "");
};

const _get_formatted_datetime = (timestampMs: string) => {
  const date = new Date(parseInt(timestampMs, 10));
  return date.toLocaleString("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  });
};
